import { citizenAddress, liveCollection, materials } from './collectes'
import type { CitizenRequest } from './demandes'

/** Requête ouverte par ATNA quand un bac n'a pas été ramassé. */
export const binRequestReference = '#REQ-2947'

export const binRequest: CitizenRequest = {
  id: 'req-2947',
  reference: binRequestReference,
  title: `Bac non ramassé — ${materials[liveCollection.material].label}`,
  service: 'Travaux publics',
  category: 'Collecte des matières résiduelles',
  address: citizenAddress,
  fullAddress: `${citizenAddress}, Brossard, Québec, J4W 2K1`,
  submittedOn: 'Envoyée aujourd’hui',
  createdOn: '11/09/26',
  resolvedOn: null,
  createdBy: 'ATNA',
  status: 'recue',
  description: `Le bac de ${materials[liveCollection.material].label.toLowerCase()} n’a pas été ramassé lors de la collecte du jour (${liveCollection.sector}, ${liveCollection.truck}). Le bac est resté au bord de la rue.`,
  attachments: [],
  timeline: [
    { date: 'Aujourd’hui', label: 'Requête ouverte par ATNA' },
    { date: 'Aujourd’hui', label: 'Transmise aux Travaux publics' },
  ],
  messages: [
    {
      id: 'msg-2947-1',
      author: 'ville',
      authorName: 'Travaux publics',
      sentAt: 'Aujourd’hui',
      body: 'Merci pour votre signalement. Un rattrapage est prévu dans les 48 heures ouvrables. Laissez votre bac au bord de la rue d’ici là.',
    },
  ],
}
